export default __webpack_public_path__ + "static/media/Julie_Dye_AHV_In_Moms_We_Trust.35726390.jpg";